import { apiSelectorFactory } from "../../../services/selectors";
import { apiKeys } from "../../../constants";
export const loginSelector = apiSelectorFactory(apiKeys.LOGIN);